import './NoPrice.css';

/** Why a no-price printing cannot be staged; the tooltip on every disabled Add to Trade. */
export const NO_PRICE_TOOLTIP = 'This printing has no price yet.';

/** Beside a disabled Create / Send / Confirm button while a staged card has no price. */
export const NO_PRICE_BLOCKS_TRADE = `${NO_PRICE_TOOLTIP} Remove it to continue.`;

/**
 * What renders where a card's point value would, when the card has no price.
 * Never a number: see hasRealPrice in utils/price.
 */
export const NoPrice = ({ className = '' }: { className?: string }) => (
  <span className={`no-price ${className}`.trim()} title={NO_PRICE_TOOLTIP} data-testid="no-price">
    No price
  </span>
);

export default NoPrice;
